import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';

interface Params {
  has_tours?: MaybeRefOrGetter<string | null>;
  country__slug?: MaybeRefOrGetter<string>;
  sorting?: MaybeRefOrGetter<'-tours_count'>;
  all?: MaybeRefOrGetter<string | null>;
}

const normalizeParams = (params: Params) => {
  return {
    country__slug: unref(params?.country__slug) as string,
    has_tours: params?.has_tours ? (unref(params?.has_tours) as string) : 'true',
    sorting: params?.sorting ? (unref(params?.sorting) as '-tours_count') : '-tours_count',
    all: params?.all ? (unref(params?.all) as string) : 'true',
  };
};

export const useRegionsInCountryInfo = (params: Params) => {
  const { getRegionsInCountry } = useExperienceApi();

  const { data: regionsInCountryInfo } = useQuery({
    queryKey: ['regionsInCountryInfo', params],
    queryFn: () => {
      return getRegionsInCountry({ query: { ...normalizeParams(params) } });
    },
    select: (response) => response.data,
    retry: false,
  });

  return {
    regionsInCountryInfo,
  };
};
